/**
 * The reprint queue: warehouse floor asks, bench prints.
 *
 * Zebra Browser Print is a localhost agent with no Android build, so the
 * handheld can never reach a printer itself. Rather than pretend otherwise,
 * the operator who finds a missing or unreadable label records the need, and
 * whichever machine has the agent picks the job up.
 */

import { api } from './api'

const BASE = '/api/labels/queue'

/**
 * Ask for a label to be printed.
 *
 * Queueing the same product twice is not an error — the backend reports the
 * existing job as success, because an operator unsure whether the request
 * landed will simply ask again, and two labels for one item is worse than a
 * silent no-op.
 */
export function queueLabelReprint({ shopifyProductId, itemId = null, title = null }) {
    return api.post(BASE, {
        shopify_product_id: String(shopifyProductId),
        item_id: itemId,
        title
    })
}

/** Outstanding reprint requests, oldest first. */
export async function pendingLabelJobs() {
    const response = await api.get(`${BASE}?status=pending`)
    return response?.jobs ?? []
}

/** Confirm a job's label actually came out of the printer. */
export function markLabelPrinted(jobId) {
    return api.post(`${BASE}/${jobId}/printed`, {})
}
